<template>
  <div>
    <app-header v-show="header_show" :showBackIcon="showBackIcon"></app-header>
    <div class="content21">
      <div class="slider-img-style">
        <!--<div class="title-head">
        </div>-->
        <div class="title-search">
          <div class="search-1" nav="1">
            <img class="showH myImg1" src="../../../static/img/icon-index-62.png">
          </div>
          <div class="search-2">
            <div class="clear"></div>
            <div class="showM" nav="2">
              <img class="showH myImg2" src="../../../static/img/icon-index-3.png">
            </div>
            <div class="showS">
              <input type="text" name="search" readonly  unselectable="on" placeholder="请输入你想查询的内容关键词">
            </div>
          </div>
          <div class="search-3" nav="3">
            <img class="showH myImg3" src="../../../static/img/icon-index-63.png">
          </div>
          <div class="clear"></div>
        </div>
        <div class="title-t">
          <span>科学城医保，欢迎您！</span>
        </div>
        <div class="title-n">
          <span id="timeText"></span>
          <span class="name" id="aac003">请登录</span>
        </div>
        <span class="title-y" nav="4">
                    查询余额
                </span>
        <div class="title-but">
          <div class="but-two but" nav="6">
            <img class="showY myImgTwo" src="../../../static/img/icon-index-65.png">
            <p>电子医保卡</p>
          </div>
          <div class="but-one but" nav="5">
            <img class="showY myImgOne" src="../../../static/img/icon-index-64.png">
            <p>门诊缴费</p>
          </div>
          <div class="but-three but" nav="7">
            <img class="showY myImgThree" src="../../../static/img/icon-index-97.png">
            <p>办事指南</p>
          </div>
          <div class="but-four but" nav="8">
            <img class="showY myImgFour" src="../../../static/img/icon-index-98.png">
            <div class="clear"></div>
            <p>政策宣传</p>
          </div>
        </div>
      </div>
      <div class="contentSix">
        <div class="query11">
          <div class="query-left" nav="20">
            <img class="showQ" src="../../../static/img/icon-index-120.png">
          </div>
          <div class="query-right">
            <div class="query-right-1 right22 top nav_left" nav="9">
              <div class="right-img22">
                <img src="../../../static/img/grzhcx.png">
                <div class="txt">个人账户<br/>信息查询</div>
              </div>
            </div>
            <div class="query-right-1 right22 top" nav="10">
              <div class="right-img22">
                <img src="../../../static/img/grbxxxcx.png">
                <div class="txt">个人就诊<br/>信息查询</div>
              </div>
            </div>
            <div class="query-right-1 right22 middle nav_left" nav="11">
              <div class="right-img22">
                <img src="../../../static/img/ddydcx.png">
                <div class="txt">定点医院<br/>药店查询</div>
              </div>
            </div>
            <div class="query-right-1 right22 middle" nav="12">
              <div class="right-img22">
                <img src="../../../static/img/ybml.png">
                <div class="txt">国家药品<br/>目录查询</div>
              </div>
            </div>
            <div class="query-right-1 right22 bottom nav_left" nav="13">
              <div class="right-img22">
                <img src="../../../static/img/icon-ydjybacx.png">
                <div class="txt">异地就医<br/>备案查询</div>
              </div>
            </div>
            <div class="query-right-1 right22 bottom" nav="14">
              <div class="right-img22 query_last">
                <div class="txt">更多信息<br/>&nbsp;&nbsp;MORE</div>
                <img src="../../../static/img/more_info.png">
              </div>
            </div>
          </div>
        </div>

        <div class="clear"></div>
        <div class="handle">
          <div class="handle-left" nav="21">
            <img class="showD" src="../../../static/img/icon-index-136.png">
          </div>
          <div class="handle-right">
            <div class="query-right-1 right22  handle_top nav_left" nav="15">
              <div class="right-img22">
                <img src="../../../static/img/icon-wsbx.png">
                <div class="txt">网上报销</div>
              </div>
            </div>
            <div class="query-right-1 right22 handle_top" nav="16">
              <div class="right-img22">
                <img src="../../../static/img/icon-ydba.png">
                <div class="txt">异地备案</div>
              </div>
            </div>
            <div class="query-right-1 right22 handle_middle nav_left" nav="17">
              <div class="right-img22">
                <img src="../../../static/img/icon-ybdt.png">
                <div class="txt">医保动态</div>
              </div>
            </div>
            <div class="query-right-1 right22 handle_middle" nav="18">
              <div class="right-img22">
                <!--<img src="../../../static/img/icon-ybtt.png">
                <div class="txt">医保头条</div>-->
                <div class="txt">更多信息<br/>&nbsp;&nbsp;MORE</div>
                <img src="../../../static/img/more_info.png">
              </div>
            </div>
<!--            <div class="query-right-1 right22 handle_middle nav_left" nav="29">-->
<!--              <div class="right-img22">-->
<!--                <img src="../../../static/img/icon-ybdt.png">-->
<!--                <div class="txt">服务评价</div>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="query-right-1 right22 handle_middle" nav="30">-->
<!--              <div class="right-img22">-->
<!--                &lt;!&ndash;<img src="../../../static/img/icon-ybtt.png">-->
<!--                <div class="txt">医保头条</div>&ndash;&gt;-->
<!--                <div class="txt">联系电话</div>-->
<!--                <img src="../../../static/img/more_info.png">-->
<!--              </div>-->
<!--            </div>-->
          </div>
          <div class="handle-left1" @click="openMask" >
            <img class="showD1" src="../../../static/img/myd.png">
          </div>
          <dialog-bar v-model="sendVal" type="confirm" title="医保服务意见箱" content="我是内容" v-on:cancel="clickCancel()" @danger="clickDanger()" @confirm="clickConfirm()" dangerText="提 交"></dialog-bar>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import header from '@/components/header/header.vue'
import footer from '@/components/footer/footer.vue'
// eslint-disable-next-line no-unused-vars
import dialogBar from '@/components/common/dialog.vue'
import $ from 'jquery'
import {MessageBox} from 'mint-ui'
// eslint-disable-next-line no-unused-vars
export default {
  components: {
    'app-header': header,
    'app-footer': footer,
    'dialog-bar': dialogBar
  },
  data () {
    return {
      header_show: false, // true和false控制头部显示或者不显示
      showBackIcon: false,
      menuItems: [
        {title: '一', value: '1'},
        {title: '二', value: '2'},
        {title: '三', value: '3'}
      ],
      menuValue: '',
      aac003_1: '99',
      sendVal: false
    }
  },
  methods: {
    openMask (index) {
      if (localStorage.getItem('aac001')) {
        this.sendVal = true
      } else {
        MessageBox.alert('请先登录!')
      }
    },
    clickCancel () {
      console.log('点击了取消')
    },
    clickDanger () {
      console.log('这里是danger回调')
    },
    clickConfirm () {
      console.log('点击了confirm')
    },
    clickGridItem (e) {
      console.log(e.type)
      // window.location.href = e.type + '.html'
      // this.$router.push({ path: e.type, title: { title: '我是谁' } })
    },
    navToPath (tag) {

    },
    setWelcomeText () {
      var aac001 = localStorage.getItem('aac001')
      if (aac001) {
        var aac003 = localStorage.getItem('aac003')
        $('#aac003').text(aac003)
        this.aac003_1 = '999'
        this.getGrzhInfo(aac001)
      } else {
        $('#aac003').text('请登录')
        $('.title-y').text('查询余额')
      }
    },
    getGrzhInfo (aac001) {
      // eslint-disable-next-line no-unused-vars
      let that = this
      var params = new URLSearchParams()
      params.append('jybh', 'KXCCX008')
      params.append('aac001', aac001)
      params.append('aac002', localStorage.getItem('aac002'))
      params.append('access_token', localStorage.getItem('access_token'))
      this.$http.post('/api/kxcwx/queryData', params).then(res => {
        if (res.data.code === '1') {
          // 验证res.data.output是否存在且不为空数组
          if (res.data.output && res.data.output.length > 0 && res.data.output[0] && res.data.output[0].zhye !== undefined) {
            $('.title-y').text('个人账户总余额:' + res.data.output[0].zhye + ' 元')
          } else {
            $('.title-y').text('个人账户总余额: -- 元')
          }
        } else {
          /* MessageBox.alert('查询个人余额失败!' + res.data.message) */
          $('.title-y').text('个人账户总余额: -- 元')
        }
      })
    }
  },
  mounted () {
    var date = new Date()
    var hour = date.getHours()
    var timeText = hour > 12 ? '下午好!' : '上午好!'
    $('#timeText').text(timeText)
    this.setWelcomeText()

    this.$event.$on('setHomeWelcome', (data) => {
      this.setWelcomeText()
    })

    let that = this
    $('*[nav]').click(function () {
      var nav = this.getAttribute('nav')
      switch (nav) {
        case '4':
          that.$router.push('/grzhTotal')
          break
        case '5':
          that.$router.push('/zjzf')
          break
        case '6':
          that.$router.push('/dzybk')
          break
        case '7':
          window.location.href = 'https://mp.weixin.qq.com/mp/homepage?__biz=MzI0OTU1ODQ3Nw==&hid=4&sn=d960386d2579c16aa93d5b2d9546c7d7&scene=18'
          break
        case '8':
          // window.location.href = 'https://mp.weixin.qq.com/s?__biz=MzI0OTU1ODQ3Nw==&mid=2247485533&idx=1&sn=93e8cf2c98636a23f62be4ff06cc336d&chksm=e98eecffdef965e9b71136fcd5bf86ef75edbec3c9c93e5e9d347258d2ab2ad611704df5b790&token=1510173860&lang=zh_CN#rd'
          window.location.href = 'http://mp.weixin.qq.com/s?__biz=MzI0OTU1ODQ3Nw==&mid=2247487287&idx=1&sn=8a0482ced5b6a0fdc71dd7d6435b0f6b&chksm=e98eeb95def962837be8135df9a560b647d015f995fd6c1efdc3408948e0bc3d6caee85a72d2&scene=18#wechat_redirect'
          break
        case '9':
          that.$router.push('/grzhTotal')
          break
        case '10':
          that.$router.push('/grbxxxcx')
          break
        case '11':
          that.$router.push('/ddyyAndYd')
          break
        case '12':
          that.$router.push('/ybml')
          break
        case '13':
          that.$router.push('/ydbaxxcx')
          break
        case '14':
          that.$router.push('/query')
          break
        case '15':
          that.$router.push('/wsbx')
          break
        case '16':
          that.$router.push('/ydba')
          break
        case '17':
          window.location.href = 'https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzI0OTU1ODQ3Nw==#wechat_redirect'
          break
        case '18':
          that.$router.push('/ywbl')
          break
        case '20':
          that.$router.push('/query')
          break
        case '21':
          that.$router.push('/ywbl')
          break
        case '29':
          that.$router.push('/ywbl')
          break
        case '30':
          that.$router.push('/ywbl')
          break
        case '99':
          if (that.aac003_1 === '999') {
            window.location.href = 'https://www.wjx.cn/vj/wk2kHZd.aspx'
            break
          }
          MessageBox.alert('请先登录!')
          break
        default:
          break
      }
    })
  }

}
</script>
<style scoped>
  @import "../../../static/css/kxc_home.css";
  .content21{
    /*margin-top: 2.5rem;*/
    height: 93vh;
    width: 100%;
    position: relative;
    overflow-y:auto;
    /*padding-bottom: 5rem;*/
  }

  .div-inline1{
    display:inline;
    float:right;
    position:absolute;
    top:90px;
  }

  .content99{
    font-size : 1rem;
    color : red;
  }

  .showY9{
    /*height: 2.4rem;*/
    display: block;
    width:40%;
    margin-left: 80px;
  }

  .handle-left1{
    width:100%;
    float: left;
  }
  .showD1{
    width: 100%;
  }
  </style>



// WEBPACK FOOTER //
// src/project/home/firstPage.vue